<template>
    <listTipsComponent />
</template>

<script>
import listTipsComponent from "@/views/tips-categories/pages/list_tips/components/list_tips_component.vue";
export default {
    name: "listTipsPage",
    components: {
        listTipsComponent
    },
}
</script>

<style lang="css" scoped>
</style>
